var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.23244 11.0002C1.54648 9.6835 1.33196 8.17163 1.62456 6.71607C1.91715 5.26051 2.69923 3.94898 3.84071 2.99961C4.9822 2.05024 6.41429 1.52026 7.8988 1.49781C9.38331 1.47537 10.8308 1.9618 12.0004 2.87622L9.50044 4.00022M7.00044 12.0002L3.92044 13.0602C5.13 14.0364 6.64931 14.5467 8.20288 14.4988C9.75645 14.4509 11.2414 13.8479 12.3886 12.7991C13.5357 11.7503 14.269 10.3252 14.4556 8.7821C14.6421 7.23902 14.2696 5.68018 13.4054 4.38822",
    stroke: "#FEFCFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh-icon.df5c8e8d1e6b890b5448b990e4f8549a.svg";
export { ForwardRef as ReactComponent };